import {Component, Input, OnInit} from "@angular/core";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  selector: 'nv-profile-resources',
  templateUrl: './nv-profile-resources.component.html',
  styles: []
})
export class NvProfileResourcesComponent implements OnInit {
  private _document: IDocument;

  @Input() set document(v: IDocument) {
    this._document = v;
  }

  get document(): IDocument {
    return this._document;
  }


  constructor(/*private watchService: WatchService*/) {
  }


  ngOnInit() {
    //<code>{{document.resources|json}}</code>
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-profile-resources/nv-profile-resources.component.ts